/** @format */

import React from "react";
import "./Banner.css"
export default function banner() {
  return (
    <div>
      <img
        className='banner'
        src='images/banner.png'
        alt='goodluck soda banner'
      />
    </div>
  );
}
